export const USER ="USER"
export const ROLE ="ROLE"
export const EMPLOYEE_PIS ="EMPLOYEE_PIS" 
export const CONTROL_CONFIGS="CONTROL_CONFIGS"
export const REQUIRED_FIELD_CONFIGS="REQUIRED_FIELD_CONFIGS"
export const DATE_LOCAL_STORAGE="DATE_LOCAL_STORAGE"
export const POST_LOGOUT_REDIRECTURI="POST_LOGOUT_REDIRECTURI"
export const TENANT_EMPLOYEE ="TENANT_EMPLOYEE"
export const SHOW_LOGIN ="SHOW_LOGIN"
export const APP_READONLY ="APP_READONLY"